<!-- <Loader :loading="loading" /> -->
<div class="rounded pb-5 w-100 bg-transparent border-0">
  <div class="mt-1 d-none d-xl-block" v-if="!isHomePage">
    <!-- ========== YOUR PORTALS / MEMBERSHIPS ========== -->
    <div v-if="show_your_portals_section" class="portal-sidebar-section w-100">
      <div class="portal-sidebar-card portal-sidebar-card-compact mb-2">
        <div class="portal-sidebar-header d-flex align-items-center justify-content-between rounded">
          <h6 v-if="cbo_domain" class="mb-0">Your Memberships</h6>
          <h6 v-else class="mb-0">
            <span v-if="school_domain">Your Grades</span>
            <span v-else>Your Portals</span>
          </h6>
        </div>

        <div class="portal-sidebar-body">
          <div class="portal-sidebar-list d-flex flex-column"
            :class="{'table-container-public': is_public, 'table-container-private': !is_public}">
            <template v-if="displayed_your_portals.length">
              <button v-for="portal in displayed_your_portals" :key="portal.id" type="button"
                class="portal-sidebar-item" :class="{ 'active': String($route.params.portal_id) === String(portal.id) }"
                @click="handlePortalClick(portal)" data-bs-dismiss="offcanvas">
                <span class="portal-sidebar-avatar">
                  {{ getInitials(portal.name) }}
                </span>
                <span class="portal-sidebar-name">
                  {{ portal.name }}
                </span>
                <i v-if="!portal.is_public" class="bx bxs-lock portal-sidebar-lock"></i>
              </button>
            </template>
          </div>
          <button v-if="has_more_your_portals" type="button"
            class="portal-sidebar-see-all btn btn-link btn-sm w-100 text-decoration-none" @click="toggle_your_portals">
            {{ show_all_your_portals ? 'See Less' : 'See All' }}
          </button>
        </div>
      </div>
    </div>

    <!-- ========== SUB-PORTALS (kept hidden as in your code) ========== -->
    <div v-if="isMasterPortal && workbook_domain && user_details.user_role==='admin'"
      class="mx-3 rounded w-100 mt-4 d-none">
      <div class="card rounded shadow-sm bg-white border-0">
        <div class="card-header bg-transparent d-flex justify-content-between align-items-center">
          <h6 class="mb-0">Sub-Portals</h6>
          <div class="ms-auto">
            <SubPortalView class="mt-2" />
          </div>
        </div>

        <div class="card-body p-0">
          <div class="table-container mt-0 w-100"
            :class="{'table-container-public': is_public, 'table-container-private': !is_public}">
            <table v-if="sub_portals.length" class="table mb-0">
              <tbody>
                <tr v-for="(subPortal, index) in sub_portals" :key="subPortal.id" class="hover-row border-0"
                  v-show="(index < visibleCount || showAll) && subPortal.name?.toLowerCase() !== 'default portal'">
                  <td class="border-0">
                    <div class="text-decoration-none text-dark d-flex align-items-center portal-icon mb-0"
                      @click="handlefilterPortal(subPortal)">
                      <div
                        class="rounded-3 d-flex align-items-center justify-content-center bg-primary text-white shadow-sm p-1 text-xs w-30px h-30px">
                        {{ getInitials(subPortal.name) }}
                      </div>
                      <div class="text-xs fw-500 mx-2">
                        {{ subPortal.name }}
                        <i v-if="!subPortal.is_public" class="bx bxs-lock text-primary text-xxs"></i>
                      </div>
                    </div>
                  </td>

                </tr>
              </tbody>
            </table>

            <p v-else class="text-secondary text-xs text-center my-3">No Available Sub-Portals</p>

            <div v-if="sub_portals.length > visibleCount" class="text-center my-2">
              <button class="btn btn-sm btn-transparent text-secondary" @click="toggleShowMore">
                <i v-if="showAll" class="bx bxs-up-arrow-circle me-1"></i>
                <i v-else class="bx bxs-down-arrow-circle me-1"></i>
                {{ showAll ? 'See Less' : 'See More' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ========== ALL PORTALS + CREATE BUTTON ========== -->
    <div class="portal-sidebar-card portal-sidebar-card-list">
      <div class="portal-sidebar-header d-flex align-items-center justify-content-between rounded">
        <h6 v-if="cbo_domain" class="mb-0">Memberships</h6>
        <h6 v-else class="mb-0">
          <span v-if="school_domain">All Grades</span>
          <span v-else>All Portals</span>
        </h6>
        <CreatePortal @create-portal="createPortal" />
      </div>

      <div class="portal-sidebar-body">
        <div class="portal-sidebar-search input-group input-group-sm mb-2">
          <span class="input-group-text">
            <i class="bi bi-search"></i>
          </span>
          <input
            v-model="portal_search_query"
            type="search"
            class="form-control"
            :placeholder="school_domain ? 'Search grades...' : cbo_domain ? 'Search memberships...' : 'Search portals...'"
          >
          <button
            v-if="portal_search_query"
            type="button"
            class="btn btn-outline-secondary"
            title="Clear search"
            @click="portal_search_query = ''"
          >
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="portal-sidebar-list d-flex flex-column"
          :class="{'table-container-public': is_public, 'table-container-private': !is_public}">
          <template v-if="visible_portals.length">
            <button v-for="portal in visible_portals" :key="portal.id" type="button" class="portal-sidebar-item"
              :class="{ 'active': String($route.params.portal_id) === String(portal.id) }"
              @click="handlePortalClick(portal)">
              <span class="portal-sidebar-avatar">
                {{ getInitials(portal.name) }}
              </span>
              <span class="portal-sidebar-name">
                {{ portal.name }}
              </span>
              <i v-if="!portal.is_public" class="bx bxs-lock portal-sidebar-lock"></i>
            </button>
          </template>
          <p v-else class="portal-sidebar-empty mb-0">
            No portals found.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="portal_request_access" tabindex="-1" aria-labelledby="portalRequestAccessModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded">
      <div class="modal-header">
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body d-flex justify-content-center">
        <p class="text-md fw-500" id="portalRequestAccessModalLabel">This is a private portal. Would you like to request
          access?</p>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-primary text-xs rounded shadow" v-if="request_access">
          <div class="spinner-border text-light spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </button>
        <button @click="requestAccess" v-else class="btn btn-primary text-xs rounded shadow"
          :disabled="!(selectedPortal?.id || selectedPortal?.portal_id)">
          Request Access
        </button>

      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="create_portal" tabindex="-1" aria-labelledby="create_portalModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content rounded">
      <form @submit.prevent="createPortal">
        <div class="modal-body">
          <h6 class="modal-title mb-3" id="create_portalModalLabel">Create Portal</h6>

          <div class="mb-3">
            <label for="portal_name" class="form-label text-xs fw-500">Portal name <span
                class="text-danger">*</span></label>
            <input type="text" class="form-control rounded text-xs" id="portal_name" placeholder="Enter portal name"
              v-model="portal_name" required>
            <p v-if="errors.portal_name" class="text-danger text-xs">{{ errors.portal_name }}</p>
          </div>
          <div class="mb-3">
            <label for="is_public" class="form-label text-xs fw-500">Visibility<span
                class="text-danger">*</span></label>
            <select class="form-select rounded text-xs" id="is_public" v-model="is_public" required>
              <option selected hidden>Select visibility type</option>
              <option value="false">Private</option>
              <option value="true">Public</option>
            </select>
          </div>
          <div v-if="String(is_public) === 'false'" class="mb-3 border rounded bg-light p-3">
            <div class="d-flex justify-content-between align-items-start gap-3">
              <div>
                <label class="text-xs fw-bold text-dark d-block mb-0" for="legacy_portal_is_visible">
                  Invite Only Portal
                </label>
                <div class="text-xs text-muted">
                  Turn this off if you want other users to see and request access to this private portal.
                </div>
              </div>
              <div class="form-check form-switch mt-1">
                <input class="form-check-input" type="checkbox" id="legacy_portal_is_visible" :checked="!is_visible"
                  @change="is_visible = !$event.target.checked">
              </div>
            </div>
          </div>
          <div class="float-end mb-3">
            <button type="button" class="btn btn-primary text-xs rounded shadow mx-1"
              data-bs-dismiss="modal">Cancel</button>
            <button type="submit" class="btn btn-primary text-xs rounded shadow">Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="offcanvas offcanvas-start" tabindex="-1" id="requested_members" aria-labelledby="portal_members_label">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="portal_label"></h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <h6 class='text-start mx-1 d-flex align-items-center'>Portal Request Members
      <i class="bx bx-plus-circle fs-5 text-primary ms-2 cursor-pointer" data-bs-toggle="modal"
        data-bs-target="#add_portal_member_modal" title="Add Member"
        v-if="user_details.user_role === 'admin' || portal_admin">
      </i>
      <i class="bx bx-trash fs-5 text-danger ms-2 cursor-pointer" data-bs-toggle="modal"
        data-bs-target="#delete_portal_member_modal" title="Delete Member"
        v-if="user_details.user_role === 'admin' || portal_admin">
      </i>
    </h6>

    <div class="table-container ">
      <table v-if="requested_users.length" class="table mb-0">
        <tbody>
          <tr v-for="member in requested_users" :key="member.id" class="hover-row border-0">
            <td class="border-0">
              <span class="text-decoration-none text-dark">
                <p class="portal-icon mb-0 d-flex align-items-center">
                  <a class="rounded-circle bg-yellow p-1 shadow-sm color-purple">
                    <i class='bx bx-user fs-5'></i>
                  </a>
                  <span class="text-xs fw-500 mx-2 color-blue">{{ member.first_name }} {{ member.last_name }}</span>
                </p>
              </span>
            </td>
            <td class="border-0 text-end">
              <button @click="approve_portal_access_request(member.id)" class="btn p-0 m-0 transparent"
                title="Admit User">
                <i class="bi bi-check-circle fs-2 text-success"></i>
              </button>
              <button @click="declineRequest(member.id)" class="btn p-0 m-0 transparent ms-1" title="Decline User">
                <i class="bi bi-x-circle fs-2 text-danger"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <p v-else class="text-secondary text-xs text-center">
        No Portal members Available
      </p>
    </div>
  </div>
</div>
